import React from 'react';
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../../utils/SEO";

export default function GibraltarTrustsPrivateWealth() {

    return (
        <main className='main'>
            <SEO
                title="Gibraltar Trusts & Wealth | Asset Protection Hub"
                description="Establish trusts in Gibraltar for asset protection, estate planning, and wealth management under a trusted UK-based legal framework."
                keywords="Gibraltar trusts, asset protection Gibraltar, wealth management Gibraltar, family office Gibraltar, discretionary trusts Gibraltar, charitable trusts Gibraltar, private wealth Gibraltar, offshore trusts"
                url="/gibraltar-trusts-private-wealth"
            />

            <IntroSection
                title="Gibraltar Trusts & Private Wealth"
                subtitle="A Secure & Respected Jurisdiction for Asset Protection"
                description="Gibraltar has a long-standing reputation as a Tier-1 trust and wealth management center, combining UK legal traditions with business-friendly taxation. Its trusts legislation, modeled on English common law, allows for discretionary, private, charitable, and purpose trusts, making Gibraltar highly flexible for wealth preservation, succession planning, and asset protection."
                badges={[
                    "Discretionary Trusts",
                    "Family Offices",
                    "Charitable & Purpose Trusts",
                    "Asset Protection"
                ]}
                buttonText="Request a Gibraltar Trust Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../../../assets/images/financial-license/financial-license.png')}
                imageAlt="Gibraltar Trusts & Private Wealth"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Choose Gibraltar for Trusts & Wealth Management?"
                        blocks={[
                            {
                                items: [
                                    { text: "Tier-1 Reputation — aligned with English common law." },
                                    { text: "Strong Regulation — supervised by GFSC, ensuring credibility." },
                                    { text: "Private Wealth Focus — attractive to HNWIs & family offices." },
                                    { text: "Tax Advantages — no capital gains, no inheritance tax, no VAT." },
                                    { text: "Flexibility — wide choice of trust types and private wealth structures." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Types of Trusts in Gibraltar"
                        blocks={[
                            {
                                title: "Discretionary Trusts",
                                items: [
                                    { text: "Most common structure." },
                                    { text: "Trustees have discretion over distributions to beneficiaries." },
                                    { text: "Widely used for asset protection and estate planning." }
                                ]
                            },
                            {
                                title: "Purpose Trusts",
                                items: [
                                    { text: "Established for a specific non-charitable purpose (e.g., holding shares in a company)." }
                                ]
                            },
                            {
                                title: "Charitable Trusts",
                                items: [
                                    { text: "For philanthropic and charitable causes." },
                                    { text: "Tax exemptions available." }
                                ]
                            },
                            {
                                title: "Private Family Trusts",
                                items: [
                                    { text: "Designed for family offices and intergenerational wealth planning." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Capital & Requirements"
                        blocks={[
                            {
                                items: [
                                    { text: "Minimum Capital: not required for trusts." },
                                    { text: "Trustee: must be licensed in Gibraltar." },
                                    { text: "Resident Presence: at least one Gibraltar-based trustee." },
                                    { text: "Audit/Reporting: not required for private trusts, but regulated trustees must maintain records." },
                                    { text: "Duration: trusts can be perpetual (no fixed maximum)." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Benefits of Gibraltar Trusts"
                        blocks={[
                            {
                                items: [
                                    { text: "English Common Law System — global familiarity." },
                                    { text: "Regulated Trustees — ensures oversight and credibility." },
                                    { text: "Confidentiality — beneficiaries’ details not publicly disclosed." },
                                    { text: "Tax Neutrality — no inheritance, CGT, or VAT." },
                                    { text: "Global Acceptance — preferred by HNWIs and institutions." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Popular Private Wealth Uses"
                        blocks={[
                            {
                                items: [
                                    { text: "Asset Protection — shielding assets from political, legal, or creditor risks." },
                                    { text: "Succession Planning — smooth inheritance and estate transfers." },
                                    { text: "Family Office Structures — centralizing wealth and investments." },
                                    { text: "Charitable Purposes — philanthropy and legacy building." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Establishment Process"
                        blocks={[
                            {
                                items: [
                                    { text: "Consultation — define trust purpose (private, family, or charitable)." },
                                    { text: "Drafting Trust Deed — prepared under Gibraltar trust law." },
                                    { text: "Appointment of Trustees — licensed local trustee required." },
                                    { text: "Transfer of Assets — property, shares, or cash transferred into trust." },
                                    { text: "Ongoing Administration — trustees manage assets as per deed." }
                                ]
                            }
                        ]}
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Setup Timeline",
                                duration: "2–4 weeks",
                            },
                            {
                                name: "Setup Costs",
                                description: "From GBP 10,000+",
                            },
                            {
                                name: "Annual Costs",
                                description: "Trustee/admin fees",
                            },
                        ]}
                    />

                    <DetailsSection
                        title= 'Why Offshore Advisory?'
                        items={
                            [
                                { text: "Expertise in trust formation, family offices, and asset protection" },
                                { text: "Access to licensed trustees, fiduciaries, and legal partners" },
                                { text: "Integration with banking, tax planning, and residency solutions" },
                                { text: "Comparative insights: Gibraltar vs Guernsey vs Jersey vs Isle of Man" },
                                { text: "Long-term administration and compliance support" }
                            ]
                        }
                        />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for secure asset protection and succession planning?"
                        description="Gibraltar offers Tier-1 trusts and private wealth structures, combining English common law with tax efficiency."
                        buttonText="Book a Gibraltar Trust Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Why Gibraltar over Guernsey or Jersey?",
        answer: "Gibraltar offers UK alignment, lower tax, and crypto/blockchain-friendly wealth structures.",
    },
    {
        question: "Is a Gibraltar trust confidential?",
        answer: "Yes — beneficiaries’ identities are not part of public record.",
    },
    {
        question: "Who can act as trustee?",
        answer: "Only licensed Gibraltar fiduciaries can act.",
    },
    {
        question: "Can trusts hold crypto or digital assets?",
        answer: "Yes — Gibraltar is crypto-friendly, trusts can hold digital assets.",
    },
    {
        question: "How long can a trust last?",
        answer: "Trusts can be perpetual (no maximum duration).",
    },
];

const testimonialsData = [
    {
        quote: "We established a Gibraltar family trust to protect our assets and plan succession. Offshore Advisory coordinated trustees and banking.",
        author: "Henry L.",
        role: "HNWI"
    },
    {
        quote: "Our charitable trust was structured in Gibraltar for global donations. Offshore Advisory managed the legal and fiduciary process.",
        author: "Anna P.",
        role: "Philanthropist"
    }
];

